import React, { useCallback, useState } from 'react'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { Form, FormGroup, Label, ModalBody } from 'reactstrap'
import ErrorBoundary from '@/components/ErrorBoundary'
import { Input, CheckBox } from '@/components/inputs'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { useLocalization } from '@/hooks/localization'
import { useDebouncedEffect } from '@/hooks/useDebouncedEffect'
import context from '@/context'

const EditDimensionDialog = React.memo(function EditReportDimensionDialog ({ item, onAction, ...props }) {
  const [name, setName] = useState(item.name)
  const [latinName, setLatinName] = useState(item.latinName)
  const [code, setCode] = useState(item.code)
  const [isActive, setIsActive] = useState(item.isActive)
  const [serverErrors, setServerErrors] = useState({})

  const id = item.id ? item.id : 0
  const onNameChange = useCallback(x => setName(x.target.value), [])
  const onLatinNameChange = useCallback(x => setLatinName(x.target.value), [])
  const onCodeChange = useCallback(x => setCode(x.target.value), [])
  const onIsActiveChange = useCallback((checked) => setIsActive(checked), [])
  const onActionButton = useCallback(() => onAction({ id, name, latinName, code, isActive }), [onAction, name, latinName, code, isActive, id])

  const { localize } = useLocalization()

  useDebouncedEffect(() => {
    if (name || latinName || code) {
      context.api.qlikDimensionsService.validateDimension({ id, name, latinName, code })
        .then(() => setServerErrors({}))
        .catch(r => {
          const error = r ? r.response ? r.response.data ? r.response.data.error : null : null : null

          setServerErrors(error)
        })
    }
  }, [name, latinName, code, id], 300)

  return (
    <React.Fragment>
      <ValidationBoundary serverError={serverErrors}>
        <BasicHeader title={item.id ? localize('Common:EditQlikDimension') : localize('Common:AddQlikDimension')} {...props} />
        <ModalBody>
          <ErrorBoundary>
            <Form>
              <FormGroup>
                <Label>{localize('Common.Name')}</Label>
                <Validator name='name' value={name} required>
                  <Input defaultValue={name} onChange={onNameChange} />
                </Validator>
              </FormGroup>
              <FormGroup>
                <Label>{localize('Common.LatinName')}</Label>
                <Validator name='latinName' value={latinName} required>
                  <Input defaultValue={latinName} onChange={onLatinNameChange} />
                </Validator>
              </FormGroup>
              <FormGroup>
                <Label>{localize('Common.Code')}</Label>
                <Validator name='code' value={code} required>
                  <Input defaultValue={code} onChange={onCodeChange} />
                </Validator>
              </FormGroup>
              <FormGroup>
                <CheckBox label={localize('Common.IsActive')} checked={isActive} onChange={onIsActiveChange} />
              </FormGroup>
            </Form>
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid, isServerValid }) =>
          <ConfirmFooter onAction={onActionButton} disabled={!isValid || !isServerValid} icon='save' {...props} />}
        />
      </ValidationBoundary>
    </React.Fragment>)
})

export default {
  component: EditDimensionDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/editDimension.js